export const FREE_IMAGES_LIST = [
    "picture_10",
    "picture_09",
    "picture_08",
    "picture_07",
    "picture_06",
    "picture_05",
    "picture_04",
    "picture_03",
    "picture_02",
    "picture_01",
    "cute_animal_01",
    "food_01",
    "cute_animal_02",
    "cute_animal_03",
    "food_02",
    "food_03",
    "food_04",
    "none_01",
    "cute_animal_04",
    "flowers_11",
    "cute_animal_09",
    "magic_04",
]